import COPY from '../../utils/copy'
import Button from '../button'
import { Formik, Form, Field } from 'formik'
import { useState } from 'react'

interface FormValues {
  email: string
}

// const validate = (values: FormValues) => {
//   const errors = {}
//   if (values.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) {
//     errors.email = COPY.INVALID_EMAIL
//   }
//   if (!values.email || values.email === 'placeholder') {
//     errors.email = COPY.REQUIRED
//   }
//   return errors
// }

export default function NewsletterForm() {
  const [isSubmitting, setIsSubmitting] = useState(false)

  function handleOnSubmit(values: FormValues) {
    setTimeout(() => {
      setIsSubmitting(true)
    }, 1500)
    console.log(values)
    setIsSubmitting(false)
  }
  return (
    <Formik
      initialValues={{
        email: '',
      }}
      // validate={validate}
      onSubmit={handleOnSubmit}
    >
      {({ isValid, dirty }) => (
        <Form className='w-screen'>
          <div className='flex flex-col sm:flex-row justify-center items-center w-full h-full'>
            <Field
              name='email'
              className='py-2.5 w-4/5 sm:w-3/5 md:w-1/2 lg:w-2/5 xl:w-1/5 max-sm:mb-2 mr-2 rounded-md bg-gray-100 shadow-lg pl-4 text-black placeholder:text-gray-500 outline-none border-2 border-gray-500 hover:border-blue-700 focus:border-blue-700'
              placeholder={COPY.EMAIL_PLACEHOLDER}
            />
            {dirty && isValid && (
              <Button
                disabled={!isValid || isSubmitting}
                type='submit'
                content={isSubmitting ? COPY.SUBSCRIBING : COPY.SUBSCRIBE}
              />
            )}
          </div>
        </Form>
      )}
    </Formik>
  )
}
